var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExtraInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    id: "svg4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4",
    transform: "translate(19.453869,5.2101021)",
    style: {
      strokeWidth: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.625202,
      fill: "#000000",
      fillOpacity: 0.298039,
      stroke: "#000000",
      strokeWidth: 0,
      strokeLinecap: "square",
      strokeMiterlimit: 0,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "fill markers stroke"
    },
    id: "rect4",
    width: 11.905278,
    height: 21.949324,
    x: -9.0151463,
    y: 1.1240454,
    ry: 4.3806419
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 6.4977566,23.262114 c 0,-0.147872 -0.119533,-0.267401 -0.2673999,-0.267401 H -9.7818828 -12.637992 c -0.147606,0 -0.267402,0.119534 -0.267402,0.267401 z M 1.6925613,22.899252 h -9.791957 V 1.8876829 H 1.692294 V 22.899252 Z m 1.147685,0 H 2.2270958 V 1.6202826 c 0,-0.1476059 -0.119533,-0.2674015 -0.2674015,-0.2674015 h -10.326491 c -0.1476053,0 -0.2674011,0.1197968 -0.2674011,0.2674015 V 22.899252 h -0.612883 z",
    id: "path1",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 2,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 1.5,
      strokeLinecap: "square",
      strokeMiterlimit: 0,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "fill markers stroke"
    },
    id: "path5",
    d: "m -4.700188,13.525153 a 0.68578875,0.68578875 0 0 1 -0.6741348,0.68569 0.68578875,0.68578875 0 0 1 -0.6970467,-0.662385 0.68578875,0.68578875 0 0 1 0.6504442,-0.708203 0.68578875,0.68578875 0 0 1 0.7191534,0.638316 l -0.6842049,0.04658 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtraInfo);
export default __webpack_public_path__ + "static/media/extra-info.adec00286e1541739c926eaa5aa92fbe.svg";
export { ForwardRef as ReactComponent };